// Helper to pick localized name/description from a menu/beverage/catering item.
// Falls back gracefully: requested-lang field → en → primary (Turkish).

export const localizedField = (item, baseField, language) => {
  if (!item) return '';
  const lang = (language || '').toLowerCase();
  // Try the requested language first
  if (lang && lang !== 'tr') {
    const localized = item[`${baseField}_${lang}`];
    if (localized && String(localized).trim()) return localized;
  }
  // Fallback to English if available
  if (lang && lang !== 'tr' && lang !== 'en') {
    const en = item[`${baseField}_en`];
    if (en && String(en).trim()) return en;
  }
  return item[baseField] || '';
};

export const getItemName = (item, language) => localizedField(item, 'name', language);
export const getItemDescription = (item, language) => localizedField(item, 'description', language);
